import { optionsStackedBar } from "./utils"

// Stacked bar chart
const figure_3_3 = {
  type: "stacked",
  layout: "full",
  figureNumber: "3.3",
  title: "Total Raised in Donations and Matching Funds, FY 2016-22",
  subTitle: "(millions of US dollars)",
  source: "Source: IMF, Communications Department.",
  data: {
    labels: ["2016", "2017", "2018", "2019", "2020", "2021", "2022"],
    datasets: [
      {
        label: "Employee and retiree donations ",
        borderColor: "#E15B29",
        backgroundColor: "#E15B29",
        data: [
          1176330.43, 1525001.79, 1655109.73, 1769461.91, 2013725.78,
          2269915.34, 2838000,
        ],
        barThickness: "flex",
        categoryPercentage: 0.9,
        maxBarThickness: 30,
      },
      {
        label: "Matching funds",
        borderColor: "#00568A",
        backgroundColor: "#00568A",
        data: [
          584199.87, 792281.98, 932031.88, 1206417.56, 1614351.94, 1827136.17,
          2412000,
        ],
        barThickness: "flex",
        categoryPercentage: 0.9,
        maxBarThickness: 30,
      },
    ],
  },
  options: {...optionsStackedBar, height: 'auto'},
}

export default figure_3_3
